import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Language = 'ar' | 'en';

interface LanguageStore {
  language: Language;
  setLanguage: (language: Language) => void;
  toggleLanguage: () => void;
  initializeLanguage: () => void;
}

export const useLanguageStore = create<LanguageStore>()(
  persist(
    (set) => ({
      language: 'ar',
      setLanguage: (language) => {
        set({ language });
        document.documentElement.lang = language;
        document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
      },
      toggleLanguage: () => {
        set((state) => {
          const newLanguage = state.language === 'ar' ? 'en' : 'ar';
          document.documentElement.lang = newLanguage;
          document.documentElement.dir = newLanguage === 'ar' ? 'rtl' : 'ltr';
          return { language: newLanguage };
        });
      },
      initializeLanguage: () => {
        const stored = localStorage.getItem('language-store');
        if (stored) {
          const parsed = JSON.parse(stored);
          const language = parsed.state?.language || 'ar';
          document.documentElement.lang = language;
          document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
        } else {
          // Auto-detect browser language
          const browserLang = navigator.language.split('-')[0];
          const language = browserLang === 'ar' ? 'ar' : 'en';
          set({ language });
          document.documentElement.lang = language;
          document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
        }
      },
    }),
    {
      name: 'language-store',
    }
  )
);

